// Sentry must be imported & initialized before other app modules
import { initSentry, Sentry } from "./lib/sentry.ts";
initSentry();

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary.tsx";
import "./index.css";

// Capture fatal errors before React mounts
window.onerror = (message, source, lineno, colno, error) => {
  (window as any).__lastFatalError = { message, source, lineno, colno, stack: error?.stack, ts: Date.now() };
  console.error("[window.onerror]", { message, source, lineno, colno, error });
  if (error) Sentry.captureException(error);
};

window.onunhandledrejection = (event) => {
  const reason = event.reason;
  (window as any).__lastFatalError = {
    message: reason?.message || String(reason),
    stack: reason?.stack,
    ts: Date.now(),
  };
  console.error("[unhandledrejection]", reason);
  Sentry.captureException(reason);
};

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
